import EditPrivacyPortalModal from './EditPrivacyPortalModal';

export default EditPrivacyPortalModal;
